import React, { useState, useEffect } from 'react';
import UseToast from 'hooks/use-toast';
import { useQueryClient } from 'react-query';
import { getAccessToken } from 'utils/authentication';
import { isUserLoggedIn } from 'utils/authentication';

import OurPlans from 'components/pages/plans/OurPlans';
import WhatYouWillGet from 'components/pages/plans/WhatYouWillGet';
import CompareSection from 'components/pages/plans/CompareSection';
import SelectYourPlanSection from 'components/pages/plans/SelectYourPlanSection';
import FAQSection from 'components/pages/plans/FAQSection';
import PromotionBanner from '@core/components/promotionbanner/PromotionBanner';
import ProofNumbers from './ProofNumbers';
import CertifiedTrust from './CertifiedTrust';
import PlansTestimonials from './PlansTestimonials';
import ZamannProduct from './ZamannProduct';

const PlansWrapper = ({ data }) => {
    const { ToastContainer, toast } = UseToast();
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    const [haspromotion, setHasPromotion] = useState(false);
     const queryClient = useQueryClient();
    useEffect(() => {
        setIsAuthenticated(isUserLoggedIn());
        data.promotion != null ? setHasPromotion(true) : setHasPromotion(false);
         queryClient.invalidateQueries(['user-metadata', getAccessToken()]);
    }, []);



    return (
        <section className='w-100'>
            <ToastContainer />
            {/* {haspromotion &&
                <PromotionBanner data={data.promotion} />
            } */}
            <OurPlans data={data} isLoggedIn={isAuthenticated} toast={toast} />
            <ProofNumbers />
            <CompareSection data={data} isLoggedIn={isAuthenticated} toast={toast}/>
            <CertifiedTrust />
            <WhatYouWillGet />            
            <SelectYourPlanSection data={data} isLoggedIn={isAuthenticated} toast={toast} />
            <PlansTestimonials  data={data.testimonials} />    
            <FAQSection />
            <ZamannProduct />

        </section>
    );
};


export default PlansWrapper;